export default __webpack_public_path__ + "static/media/back4.9d8df76f.png";